<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-2 col-sm-1">
              <v-text-field label="DIO" v-model="current.dio.codigo" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="Número" v-model="current.numero" outlined dense disabled></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="Descrição" v-model="current.descricao" outlined dense></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field label="Comentário" v-model="current.comentario" outlined dense></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field label="Sinal" v-model="current.sinal" outlined dense></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null
  }),
  created: function() {
    this.load();
  },
  methods: {
    load: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/dio_porta/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function() {
          console.log("falha ao recuperar dados");
        });
    },
    save: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .put("/dio_porta/" + this.current.id, this.current, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function() {
          alert("DIO porta atualizado com sucesso!");
          router.push({ path: "/dio_porta/dio/" + me.current.dio.id });
        })
        .catch(function() {
          console.log("Falha ao salvar!");
        });
    }
  }
};
</script>